import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxCaptchaModule } from 'ngx-captcha';
import { MatIconModule } from '@angular/material/icon';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
// Componentes
import { CardComponent } from 'src/app/shared/card/card.component';
import { FiltersComponent } from 'src/app/shared/filters/filters.component';
// import { LoaderComponent } from 'src/app/shared/loader/loader.component';
import { LoadingComponent } from 'src/app/shared/loading/loading.component';
import { MicroLoaderComponent } from 'src/app/shared/micro-loader/micro-loader.component';
// import { ModalComponent } from 'src/app/shared/modal/modal.component';
import { BcConnectComponent } from 'src/app/shared/bc-connect/bc-connect.component';
import { BannerGoogleAdsComponent } from 'src/app/shared/banner-google-ads/banner-google-ads.component';
import { BcConectaExcelcreditComponent } from 'src/app/shared/bc-connect/bc-conecta-excelcredit/bc-conecta-excelcredit.component';
import { BcConectaSolventaComponent } from 'src/app/shared/bc-connect/bc-conecta-solventa/bc-conecta-solventa.component';
import { ConfirmTelephoneComponent } from '../../shared/confirm-telephone/confirm-telephone.component';
import { SponsorsComponent } from 'src/app/shared/sponsors/sponsors.component';
import { StepperComponent } from 'src/app/shared/stepper/stepper.component';
import { BcConectaWasticreditComponent } from 'src/app/shared/bc-connect/bc-conecta-wasticredit/bc-conecta-wasticredit.component';
import { CustomSelectComponent } from 'src/app/shared/custom-select/custom-select.component';
import { SoftFiltersComponent } from 'src/app/shared/soft-filters/soft-filters.component';
import { BcConectaCreditos365Component } from 'src/app/shared/bc-connect/bc-conecta-creditos365/bc-conecta-creditos365.component';
import { UiButtonAtomComponent } from 'src/app/shared/ui/atoms/ui-button/ui-button.component';
import { UiSponsorBadgeAtomComponent } from 'src/app/shared/ui/atoms/ui-sponsor-badge/ui-sponsor-badge.component';
import { UiCheckListItemAtomComponent } from 'src/app/shared/ui/atoms/ui-check-list-item/ui-check-list-item.component';
import { UiBenefitBadgeAtomComponent } from 'src/app/shared/ui/atoms/ui-benefit-badge/ui-benefit-badge.component';
import { UiSelectAtomComponent } from 'src/app/shared/ui/atoms/ui-select/ui-select.component';
import { CardOfferOrganismComponent } from 'src/app/shared/ui/organisms/card-offer/card-offer.component';
import { FilterPanelComponent } from 'src/app/shared/ui/organisms/filter-panel/filter-panel.component';
import { AppliedOfferCardComponent } from 'src/app/shared/ui/organisms/applied-offer-card/applied-offer-card.component';
import { OfferDetailViewOrganismComponent } from 'src/app/shared/ui/organisms/offer-detail-view/offer-detail-view.component';
import { FooterComponent } from 'src/app/shared/ui/organisms/app-footer/footer.component';


@NgModule({
  declarations: [
    CardComponent,
    FiltersComponent,
    // LoaderComponent,
    LoadingComponent,
    MicroLoaderComponent,
    // ModalComponent,
    BannerGoogleAdsComponent,
    BcConnectComponent,
    BcConectaExcelcreditComponent,
    BcConectaSolventaComponent,
    ConfirmTelephoneComponent,
    SponsorsComponent,
    StepperComponent,
    BcConectaWasticreditComponent,
    CustomSelectComponent,  
    SoftFiltersComponent,
    BcConectaCreditos365Component
  ],
  imports: [
    CommonModule,
    FormsModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgxCaptchaModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
    UiButtonAtomComponent,
    UiSponsorBadgeAtomComponent,
    UiCheckListItemAtomComponent,
    UiBenefitBadgeAtomComponent,
    UiSelectAtomComponent,
    CardOfferOrganismComponent,
    FilterPanelComponent,
    AppliedOfferCardComponent,
    OfferDetailViewOrganismComponent,
    FooterComponent,
  ],
  exports:[
    CardComponent,
    FiltersComponent,
    // LoaderComponent,
    LoadingComponent,
    MicroLoaderComponent,
    // ModalComponent,
    BannerGoogleAdsComponent,
    BcConnectComponent,
    ConfirmTelephoneComponent,
    SponsorsComponent,
    StepperComponent,
    BcConectaCreditos365Component,
    CustomSelectComponent,
    AppliedOfferCardComponent,
    OfferDetailViewOrganismComponent,
    FooterComponent
  ]
})
export class SharedModule { }
